<meta name="viewport" content="width=device-width, initial-scale=1" />
@if (
	!isLoadingLabels &&
	!isLoadingStyleSheetList &&
	!isLoadingProfile &&
	!isLoadingAvailableCustomers &&
	!isLoadingStyleSheet &&
	!isLoadingSessionStatus
) {
	<div
		class="main-view-container"
		[ngClass]="{
			'profile-open': isProfileMenuOpen() === true,
			'profile-close': isProfileMenuOpen() === false,
		}">
		@if (isLoggedIn && !isOnNoMenuPages) {
			<div class="top-bar">
				<div>
					<div class="header-menu">
						@if (menuLateralService.menuLateralViewMode() === 'hamburgerOpen') {
							<div>
								<fa-icon
									[icon]="menuLateralService.isMenuExpanded() ? icons.faTimes : icons.faBars"
									(click)="menuLateralService.setIsMenuExpanded($event, !menuLateralService.isMenuExpanded())"></fa-icon>
							</div>
						}
						@if (ProfileService.userData()) {
							<div
								class="profile-image"
								[ngClass]="{
									'remote-profile-view': ProfileService.userData()?.sourceIdBehalfOf !== undefined,
								}"
								(click)="GlobalService.isProfileMenuOpen.set(!GlobalService.isProfileMenuOpen())">
								<span class="name">
									{{ ProfileService.userData().firstNameLetters ?? '' }}
								</span>
								<span class="remote-icon">
									<fa-icon [icon]="icons.faEye"></fa-icon>
								</span>
							</div>
						} @else {
							<cpi-dot-bounce-loading-effect class="profile-image" [color]="'var(--white)'"> </cpi-dot-bounce-loading-effect>
						}
					</div>
					@if (!isLoadingLogo && logoImagePath !== '') {
						<a [href]="'/'">
							<div class="menu-logo">
								<img class="img-logo full" [src]="environment.logoSource + logoImagePath + '_horizontal.svg'" />
							</div>
						</a>
					}
				</div>

				<div class="menu-search">
					@if (showCustomerDropdown) {
						<msp-select [options]="availableCustomersOptions()" (onChange)="updateUserCustomer($event[0])"> </msp-select>
					}

					@if (!PermissionService.getPermission('GERAL_hide_search')) {
						<div>
							<input
								type="text"
								placeholder="{{ labels.lbl_geral_pesquisar }}"
								[value]="searchbarText"
								(input)="searchbarText = $event.target.value"
								(keydown)="searchToolSubmit($event)" />
							<label (click)="searchToolSubmit($event)"><fa-icon [icon]="icons.faSearch"></fa-icon></label>
						</div>
					}
				</div>
			</div>
		}
		<div class="body-container" [ngClass]="[menuLateralService.menuLateralViewMode()]">
			@if (isLoggedIn && !isOnNoMenuPages) {
				<app-menu-lateral [labels]="labels" (disconnect)="isModalOpen = true"> </app-menu-lateral>
			}
			<router-outlet></router-outlet>
		</div>

		@if (isProfileMenuOpen() === true) {
			<div class="close-profile" (click)="isProfileMenuOpen.set(!isProfileMenuOpen())"></div>
		}
	</div>

	@if (AuthLoginService.isLoggedIn() && ProfileService.userData() !== undefined) {
		<app-menu-profile
			[user]="ProfileService.userData()"
			[availableCustomers]="availableCustomers"
			[ngClass]="{
				'profile-open': isProfileMenuOpen() === true,
				'profile-close': isProfileMenuOpen() === false,
			}"
			[labels]="labels">
		</app-menu-profile>
	}
}

@if (isModalOpen) {
	<div class="disconnectBubble">
		<div class="closeProfile" id="closeModal" (click)="closeModal($event)">
			<div class="disconnectModal">
				<span class="title">{{ labels.lbl_geral_desconectar }}?</span>
				<span class="button-container">
					<span class="button danger" id="closeModal2" (click)="closeModal($event)">{{ labels.lbl_geral_nao }}</span>
					<span class="button success" (click)="logoff()">{{ labels.lbl_geral_sim }}</span>
				</span>
			</div>
		</div>
	</div>
}

<div class="notification-container">
	@for (notification of NotificationService.onScreenNotificationLine; track notification; let index = $index) {
		<div class="notification" [ngClass]="{ toLeave: notification.toLeave }">
			<div class="header">
				<span>{{ labels.lbl_geral_notificacao }}</span>
				<span (click)="NotificationService.closeNotification(index)"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
			</div>
			<div
				class="body"
				[ngClass]="{ function: notification.functionOnMessage }"
				(click)="notification.functionOnMessage ? notification.functionOnMessage() : null">
				{{ notification.notificationMessage }}
			</div>
			<div class="bar-timer loading" [style.animationDuration.ms]="notification.timerMS"></div>
		</div>
	}
</div>

@if (LoadingNotificationService.loadingNotificationLine.length > 0) {
	<div class="loading-notification-container">
		<div class="header">
			<span (click)="LoadingNotificationService.minimize = !LoadingNotificationService.minimize"
				><fa-icon [icon]="icons.faWindowMinimize"></fa-icon
			></span>
			<span (click)="LoadingNotificationService.closeAllNotifications()"><fa-icon [icon]="icons.faTimes"></fa-icon></span>
		</div>
		@if (!LoadingNotificationService.minimize) {
			<div class="body">
				@for (loadingNotification of LoadingNotificationService.loadingNotificationLine; track loadingNotification) {
					<div class="loading-notification">
						<div>
							@if (loadingNotification.icon) {
								<span><fa-icon [icon]="icons[loadingNotification.icon]"></fa-icon></span>
							}
							<span>{{ loadingNotification.text }}</span>
						</div>
						<div class="icon-container">
							@if (loadingNotification.status === 'loading') {
								<span class="loading">
									<cpi-ring-loading-effect [color]="'var(--primary-color-1)'"></cpi-ring-loading-effect>
								</span>
							}
							@if (loadingNotification.status === 'error') {
								<span class="error">
									<fa-icon [icon]="icons.faTimes"></fa-icon>
								</span>
							}
							@if (loadingNotification.status === 'success') {
								<span class="success">
									<fa-icon [icon]="icons.faCheck"></fa-icon>
								</span>
							}
							@if (loadingNotification.status === 'attention') {
								<span class="attention">
									<fa-icon [icon]="icons.faExclamation"></fa-icon>
								</span>
							}
						</div>
					</div>
				}
			</div>
		}
	</div>
}

@if (ContextMenuService.displayContextMenu) {
	<cpi-context-menu
		[ngStyle]="{
			'top.px': ContextMenuService.y,
			'left.px': ContextMenuService.x,
		}">
	</cpi-context-menu>
}

@if (PermissionService.getPermission('view_abi')) {
	<div
		class="abi-bubble"
		[ngStyle]="{
			left: abiBubbleData.left + 'px',
			top: abiBubbleData.top + 'px',
		}"
		(mousedown)="abiMouseDown()"
		[ngClass]="{
			show:
				!abiBubbleData.isOpen &&
				!isLoadingLabels &&
				!isLoadingStyleSheetList &&
				!isLoadingProfile &&
				!isLoadingAvailableCustomers &&
				!isLoadingStyleSheet &&
				!isLoadingSessionStatus,
		}">
		<!-- <span>
			<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-2)'" [size]="4" [type]="'bounce'"></cpi-dot-bounce-loading-effect>
		</span> -->
		<img src="../assets/images/abi_avatar.png" />
	</div>
}

@if (PermissionService.getPermission('view_abi')) {
	<div
		class="abi-container"
		[ngClass]="{
			show:
				abiBubbleData.isOpen &&
				!isLoadingLabels &&
				!isLoadingStyleSheetList &&
				!isLoadingProfile &&
				!isLoadingAvailableCustomers &&
				!isLoadingStyleSheet &&
				!isLoadingSessionStatus,
		}">
		<iframe src="https://abi-2-0-febraban.azurewebsites.net/abi"></iframe>
		<div class="close-abi" (click)="abiBubbleData.isOpen = !abiBubbleData.isOpen">
			<fa-icon [icon]="icons.faTimes"></fa-icon>
		</div>
	</div>
}

@if (abiBubbleData.hold === true) {
	<div class="abi-plastic-wrap" (mouseup)="abiMouseUp()" (mousemove)="abiBubbleData.hold === true ? abiMouseMove($event) : null"></div>
}

@if (
	!isLoadingStyleSheet &&
	(isLoadingLabels || isLoadingStyleSheetList || isLoadingProfile || isLoadingAvailableCustomers || isLoadingSessionStatus)
) {
	<div class="loading-container">
		<cpi-svg-gears></cpi-svg-gears>
		<cpi-dot-bounce-loading-effect class="mt-4" [color]="'var(--primary-color-1)'" [size]="16"></cpi-dot-bounce-loading-effect>
	</div>
}
